// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1454":"21c70c62","3308":"21c70c62","3447":"21c70c62","3613":"21c70c62","5120":"21c70c62","5744":"21c70c62","5775":"21c70c62","8011":"59266cc3"}[chunkId] + ".chunk.css";
};